import { Button, Dialog, DialogContent, DialogActions } from '@mui/material';

export interface PrivacyPolicyTranslations {
  close: string;
  [key: string]: string;
}

interface PrivacyPolicyDialogProps {
  isOpen: boolean;
  onClose: () => void;
  currentLanguage: string;
  timestamp: number;
  t: PrivacyPolicyTranslations;
}

const PrivacyPolicyDialog: React.FC<PrivacyPolicyDialogProps> = ({ isOpen, onClose, currentLanguage, timestamp, t }) => (
  <Dialog open={isOpen} onClose={onClose}
    sx={{
      '& .MuiDialog-paper': {
        width: '80%',
        maxWidth: '600px',
        height: '80%',
      }
    }}>
    <DialogContent>
      <iframe
        src={currentLanguage === 'zh'
          ? `https://cms.hkstylist.com/商戶隱私政策/?t=${timestamp}`
          : `https://cms.hkstylist.com/business-privacy-policy/?t=${timestamp}`}
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        title="Privacy Policy"
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        {t.close}
      </Button>
    </DialogActions>
  </Dialog>
);

export default PrivacyPolicyDialog;
